import { Grid, Typography } from '@mui/material';
import React from 'react';

interface AbonoDetallesTotalProps {
    montoDescuento: number,
    montoTotal: number
}

const AbonoDetallesTotal: React.FC<AbonoDetallesTotalProps> = ({
    montoDescuento,
    montoTotal
}) => {
    return (
        <Grid container justifyContent="flex-end" sx={{ mt: 2 }}>
            <Grid item sx={{ width: 300 }}>
                <Grid container justifyContent="space-between">
                    <Typography>Subtotal</Typography>
                    <Typography>
                        {(montoTotal - (montoDescuento || 0)).toFixed(2)}
                    </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                    <Typography>Descuento</Typography>
                    <Typography>
                        {(montoDescuento || 0).toFixed(2)}
                    </Typography>
                </Grid>
                <Grid container justifyContent="space-between">
                    <Typography fontWeight={500}>Total</Typography>
                    <Typography fontWeight={500}>
                        {montoTotal.toFixed(2)}
                    </Typography>
                </Grid>
            </Grid>
        </Grid>
    )
};
 export default AbonoDetallesTotal;